import { render, staticRenderFns } from "./EventRequestsContainer.vue?vue&type=template&id=08475757&scoped=true"
import script from "./EventRequestsContainer.vue?vue&type=script&lang=js"
export * from "./EventRequestsContainer.vue?vue&type=script&lang=js"
import style0 from "./EventRequestsContainer.vue?vue&type=style&index=0&id=08475757&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08475757",
  null
  
)

export default component.exports